export const COLUMNS = [
  { id: 'course_tasks', label: 'Kurs-Aufgaben' },
  { id: 'idea', label: 'Ideen' },
  { id: 'todo', label: 'To-do' },
  { id: 'in_progress', label: 'In Arbeit' },
  { id: 'meeting', label: 'Besprechung' },
  { id: 'backlog', label: 'Backlog' },
  { id: 'done', label: 'Erledigt' },
];

export const PRIORITIES = [
  { value: 'low', label: 'Niedrig', color: 'bg-muted text-muted-foreground' },
  { value: 'normal', label: 'Normal', color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300' },
  { value: 'high', label: 'Hoch', color: 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-300' },
  { value: 'urgent', label: 'Dringend', color: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300' },
];

export const AREAS = [
  'Allgemein', 'Ausbildung', 'Lernplattform', 'Webinare', 'Marketing', 'Technik', 'Design', 'Termine',
];

export const AREA_COLORS: Record<string, string> = {
  Allgemein: 'bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300',
  Ausbildung: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300',
  Lernplattform: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  Webinare: 'bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300',
  Marketing: 'bg-pink-100 text-pink-700 dark:bg-pink-900/40 dark:text-pink-300',
  Technik: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
  Design: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-900/40 dark:text-cyan-300',
  Termine: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
};

export const COLOR_LABELS = [
  { value: '__none__', label: 'Keine', css: '' },
  { value: 'red', label: 'Rot', css: 'bg-red-500' },
  { value: 'orange', label: 'Orange', css: 'bg-orange-500' },
  { value: 'yellow', label: 'Gelb', css: 'bg-yellow-500' },
  { value: 'green', label: 'Grün', css: 'bg-green-500' },
  { value: 'blue', label: 'Blau', css: 'bg-blue-500' },
  { value: 'purple', label: 'Lila', css: 'bg-purple-500' },
];

export const ENTITY_TYPES = [
  { value: 'course', label: 'Kurs' },
  { value: 'bundle', label: 'Bundle' },
  { value: 'category', label: 'Kategorie' },
];

export const COLOR_LABEL_BORDER: Record<string, string> = {
  red: 'border-l-red-500',
  orange: 'border-l-orange-500',
  yellow: 'border-l-yellow-500',
  green: 'border-l-green-500',
  blue: 'border-l-blue-500',
  purple: 'border-l-purple-500',
};
